import { apiClient } from 'api'
import { Stage } from 'types/stage'

export const getStages = () => apiClient.get<Stage[]>('/stage')
